import React from "react"
import Loadable from "react-loadable"

export default Loadable({
  loader: () => import(/* webpackChunkName: "CRecaptcha" */ "./CRecaptcha_web"),
  loading: () => <div />,
  // modules: ["LandingChunk"],
})
